import React from 'react'

import { useSelector } from 'react-redux'

import { Flex, Table } from '@driftt/dds'
import { ChartCard } from '@driftt/dds.reports'

import { CONFIG_BY_TYPE } from 'components/charts/TableBarChart/constants'
import {
  ITableBarChartConfig,
  TableBarChartDataType,
} from 'components/charts/TableBarChart/types'
import UserCell from 'components/core/UserCell'
import useQueryConfig from 'hooks/useQueryConfig'
import * as OrgSelectors from 'modules/org/selectors'

import useMeetingsTopPerformers from './useMeetingsTopPerformers.hook'

const dataType = TableBarChartDataType.MEETINGS_BY_REP
const tableConfig: ITableBarChartConfig = CONFIG_BY_TYPE[dataType]

const TopPerformersChart = () => {
  const { queryConfig } = useQueryConfig('meetingsByRep')

  const { metric } = useMeetingsTopPerformers(queryConfig)

  const { orgUsersById } = useSelector((state) => ({
    orgUsersById: OrgSelectors.unfilteredOrgUsersById(state),
  }))

  return (
    <ChartCard
      css={{
        paddingX: 0,
        paddingBottom: 0,
      }}
    >
      <Flex
        fullWidth
        grow={1}
        css={{
          paddingX: '$3',
        }}
      >
        <ChartCard.Header
          title={tableConfig.title}
          subtitle={tableConfig.subtitle as string}
        />
      </Flex>
      <ChartCard.Content>
        {metric && (
          <Table
            disableBoxShadow
            rows={metric}
            columns={[
              {
                value: 'user',
                header: 'Drift teammate',
                cell: ({ user }) => <UserCell user={orgUsersById[user]} />,
              },
              {
                value: 'value',
                header: 'Meetings booked',
                cell: ({ value }) => value.toLocaleString(),
              },
            ]}
          />
        )}
      </ChartCard.Content>
    </ChartCard>
  )
}

export default TopPerformersChart
